import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    borderRadius: '8px',
    '& fieldset': {
      borderColor: '#e2e8f0',
    },
    '&:hover fieldset': {
      borderColor: '#232536',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#232536',
      borderWidth: '2px',
    },
  },
}));

const SearchBar = ({ value, onChange, onSearch, placeholder, fullWidth, sx = {} }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) {
      e.preventDefault();
      onSearch(localValue);
    }
  };

  return (
    <StyledTextField
      placeholder={placeholder || 'Search...'}
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      size="small"
      fullWidth={fullWidth}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ fontSize: 20, color: '#6b7280' }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
